import { QueryClient } from '@tanstack/react-query';
import produce from 'immer';

import { findStudentIdByUuid } from '~teacher/components/ActivityResult/hooks/useActivityLiveEvent/utils';
import { ActivityResponse } from '~teacher/hook';
import { Student } from '~teacher/models/activities';

export const updateStudentJoin = ({
  uuid,
  isRosteredRoom,
}: {
  uuid: string;
  isRosteredRoom: boolean;
}) =>
  produce((activityData: ActivityResponse) => {
    const studentId = findStudentIdByUuid(activityData, uuid);
    if (studentId) {
      activityData.students[studentId].isPresent = true;
    } else if (!isRosteredRoom) {
      const newStudent: Student = {
        id: Date.now(), // tempId
        isFinished: false,
        isPresent: true,
        name: uuid,
        userUuid: uuid,
      };
      activityData.students[newStudent.id] = newStudent;
    }

    return activityData;
  });

export const studentJoinCacheUpdater = ({
  queryClient,
  activityInstanceId,
  isRosteredRoom,
  uuid,
}: {
  queryClient: QueryClient;
  activityInstanceId: number;
  isRosteredRoom: boolean;
  uuid: string;
}) => {
  queryClient.setQueryData(
    ['activity', activityInstanceId],
    updateStudentJoin({
      uuid: uuid,
      isRosteredRoom: isRosteredRoom,
    })
  );
};
